import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { clsx } from "./auth-service-tools193.js";
import { CheckIcon } from "./auth-service-tools320.js";
import { ScrollArea } from "./auth-service-tools251.js";
import { Combobox } from "./auth-service-tools331.js";
import { defaultOptionsFilter } from "./auth-service-tools349.js";
import { isEmptyComboboxData } from "./auth-service-tools350.js";
import { isOptionsGroup } from "./auth-service-tools351.js";
import { validateOptions } from "./auth-service-tools352.js";
import classes from "./auth-service-tools330.js";

function isValueChecked(value, optionValue) {
  return Array.isArray(value) ? value.includes(optionValue) : value === optionValue;
}

function Option(_ref) {
  let {
    data,
    withCheckIcon,
    value,
    checkIconPosition,
    unstyled,
    renderOption
  } = _ref;

  if (!isOptionsGroup(data)) {
    const checked = isValueChecked(value, data.value);
    const check = withCheckIcon && checked && /* @__PURE__ */jsxRuntimeExports.jsx(CheckIcon, {
      className: classes.optionsDropdownCheckIcon
    });
    const defaultContent = /* @__PURE__ */jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [checkIconPosition === "left" && check, /* @__PURE__ */jsxRuntimeExports.jsx("span", {
        children: data.label
      }), checkIconPosition === "right" && check]
    });
    return /* @__PURE__ */jsxRuntimeExports.jsx(Combobox.Option, {
      value: data.value,
      disabled: data.disabled,
      className: clsx({
        [classes.optionsDropdownOption]: !unstyled
      }),
      "data-reverse": checkIconPosition === "right" || void 0,
      "data-checked": checked || void 0,
      "aria-selected": checked,
      active: checked,
      children: typeof renderOption === "function" ? renderOption({
        option: data,
        checked
      }) : defaultContent
    });
  }

  const options = data.items.map(item => /* @__PURE__ */jsxRuntimeExports.jsx(Option, {
    data: item,
    value,
    unstyled,
    withCheckIcon,
    checkIconPosition,
    renderOption
  }, item.value));
  return /* @__PURE__ */jsxRuntimeExports.jsx(Combobox.Group, {
    label: data.group,
    children: options
  });
}

function OptionsDropdown(_ref2) {
  let {
    data,
    hidden,
    hiddenWhenEmpty,
    filter,
    search,
    limit,
    maxDropdownHeight,
    withScrollArea = true,
    filterOptions = true,
    withCheckIcon = false,
    value,
    checkIconPosition,
    nothingFoundMessage,
    unstyled,
    labelId,
    renderOption,
    scrollAreaProps,
    "aria-label": ariaLabel
  } = _ref2;
  validateOptions(data);
  const shouldFilter = typeof search === "string";
  const filteredData = shouldFilter ? (filter || defaultOptionsFilter)({
    options: data,
    search: filterOptions ? search : "",
    limit: limit != null ? limit : Infinity
  }) : data;
  const isEmpty = isEmptyComboboxData(filteredData);
  const options = filteredData.map(item => /* @__PURE__ */jsxRuntimeExports.jsx(Option, {
    data: item,
    withCheckIcon,
    value,
    checkIconPosition,
    unstyled,
    renderOption
  }, isOptionsGroup(item) ? item.group : item.value));
  return /* @__PURE__ */jsxRuntimeExports.jsx(Combobox.Dropdown, {
    hidden: hidden || hiddenWhenEmpty && isEmpty,
    children: /* @__PURE__ */jsxRuntimeExports.jsxs(Combobox.Options, {
      labelledBy: labelId,
      "aria-label": ariaLabel,
      children: [withScrollArea ? /* @__PURE__ */jsxRuntimeExports.jsx(ScrollArea.Autosize, {
        mah: maxDropdownHeight != null ? maxDropdownHeight : 220,
        type: "scroll",
        scrollbarSize: "var(--combobox-padding)",
        offsetScrollbars: "y",
        ...scrollAreaProps,
        children: options
      }) : options, isEmpty && nothingFoundMessage && /* @__PURE__ */jsxRuntimeExports.jsx(Combobox.Empty, {
        children: nothingFoundMessage
      })]
    })
  });
}

export { OptionsDropdown };